/**
 * @generated SignedSource<<dc713ea3c71cad5d57b7f5c831ece7db>>
 * @relayHash 2f5d3679776f11daa4eccecd35dae85e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e1d4be0e4e8ce9b4c81c2bdec447f04835d6249940850eb6ade0a1fe016b40f

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceInlineMarkerType = "COMMENT" | "REACTION" | "%future added value";
export type InlineReactionsPubSubHandlerActiveDataRefetchQuery$variables = {
  cloudId: string;
  contentId: string;
};
export type InlineReactionsPubSubHandlerActiveDataRefetchQuery$data = {
  readonly confluence_activeInlineData: {
    readonly reactions: ReadonlyArray<{
      readonly commentId: string;
      readonly markerRef: string;
      readonly type: ConfluenceInlineMarkerType;
    } | null | undefined>;
  } | null | undefined;
};
export type InlineReactionsPubSubHandlerActiveDataRefetchQuery = {
  response: InlineReactionsPubSubHandlerActiveDataRefetchQuery$data;
  variables: InlineReactionsPubSubHandlerActiveDataRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluenceActiveInlineData",
    "kind": "LinkedField",
    "name": "confluence_activeInlineData",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceInlineMarker",
        "kind": "LinkedField",
        "name": "reactions",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "commentId"
          },
          {
            "kind": "ScalarField",
            "name": "markerRef"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2f5d3679776f11daa4eccecd35dae85e",
    "id": "8e1d4be0e4e8ce9b4c81c2bdec447f04835d6249940850eb6ade0a1fe016b40f",
    "metadata": {},
    "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
    "operationKind": "query",
    "text": "query InlineReactionsPubSubHandlerActiveDataRefetchQuery($cloudId:ID!,$contentId:ID!){confluence_activeInlineData(cloudId:$cloudId,contentId:$contentId){reactions{commentId,markerRef,type}}}"
  }
};
})();

(node as any).hash = "be7a25bc5dc7583ac8cffc6c204b17f0";

export default node;
